<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <div class="w-full mt-5 flex-sb flex-m p-l-20">
          <md-button @click="goToWine" class="md-primary md-dense mr-10">
            Rượu vang
          </md-button>
          <md-button class="md-success md-dense mr-10" @click="addNews">
            Thêm phụ kiện
          </md-button>
          <md-button
            class="md-success mr-10 md-dense"
            @click="dialogVisible.arrangeItem = true"
          >
            Sắp xếp
          </md-button>
          <div class="md-layout md-size-100 ml-15">
            <div class="md-layout-item md-size-25">
              <md-autocomplete
                v-model="filter.name"
                :md-options="nameSuggesstion"
                :md-open-on-focus="true"
              >
                <label>Tên sản phẩm</label>

                <template slot="md-autocomplete-empty" slot-scope="{ term }"
                  >"{{ term }}" không tồn tại</template
                >
              </md-autocomplete>
            </div>
            <div class="md-layout-item md-size-25">
              <md-autocomplete
                v-model="filter.type"
                :md-options="typeSuggesstion"
                :md-open-on-focus="true"
              >
                <label>Loại sản phẩm</label>
                <template slot="md-autocomplete-empty" slot-scope="{ term }"
                  >"{{ term }}" không tồn tại</template
                >
              </md-autocomplete>
            </div>
          </div>
        </div>
        <md-card-content>
          <md-table
            :value="dataFilter"
            class="table-products table-hover"
            table-header-color="green"
            :key="reRenderTable"
            id="accessories"
          >
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              @click="editItem(item)"
              class="clickable"
            >
              <md-table-cell
                md-label="Mã phụ kiện"
                class="table-cell"
                align="left"
              >
                {{ item.data.productId }}
              </md-table-cell>
              <md-table-cell
                md-sort-by="name"
                md-label="Tên phụ kiện"
                class="table-cell"
              >
                {{
                  item.data.name.length > 20
                    ? item.data.name.substring(0, 20) + "..."
                    : item.data.name
                }}
                <md-tooltip v-show="item.data.name.length > 20">{{
                  item.data.name
                }}</md-tooltip>
              </md-table-cell>
              <md-table-cell
                md-label="Hình ảnh"
                class="table-cell"
                align="center"
              >
                <div class="image-container">
                  <img :src="item.data.pictureThumbnail" class="box-image" />
                </div>
              </md-table-cell>
              <md-table-cell
                md-label="Loại sản phẩm"
                class="table-cell"
                align="left"
              >
                {{ item.data.type[0] }}
              </md-table-cell>
              <md-table-cell
                md-label="Giá bán"
                class="table-cell"
                align="right"
              >
                {{ formatMoney(item.data.price) }}
              </md-table-cell>
              <md-table-cell
                md-label="Số lượng"
                class="table-cell"
                align="right"
              >
                {{ item.data.warehouse }}
              </md-table-cell>
              <md-table-cell md-label="Đơn vị tính" class="table-cell">
                {{ item.data.unit }}
              </md-table-cell>
              <md-table-cell
                md-label="Ẩn/hiện"
                class="table-cell"
                align="center"
              >
                <button
                  class="btnHideShow clickable"
                  v-bind:class="{ btnShow: !item.data.isHide }"
                  @click.stop="hideProduct(item)"
                >
                  {{ item.data.isHide ? "Ẩn" : "Hiện" }}
                </button>
              </md-table-cell>
              <md-table-cell class="table-cell" align="center">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.stop="removeItem(item)"
                  style="margin-right: 5px"
                >
                  <md-icon>close</md-icon>
                  <md-tooltip>Xóa sản phẩm</md-tooltip>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Hiển thị từ {{ from + 1 }} đến {{ dataFilter.length }} trong số
              {{ dataFilter.length }}
            </p>
          </div>
          <span v-show="queriedData.length < pagination.perPage"
            >Đã tải hết dữ liệu</span
          >
          <!-- <div class="pagination clickable">
            <pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </pagination>
          </div> -->
        </md-card-actions>
      </md-card>
    </div>
    <ArrangeItem
      v-if="dialogVisible.arrangeItem"
      @closeDialog="dialogVisible.arrangeItem = false"
      :showDialog="dialogVisible.arrangeItem"
    />
  </div>
</template>
<script>
import firebase from "@/services/firebase-init.js";
import Swal from "sweetalert2";
import { Pagination } from "@/components";
import { mapGetters } from "vuex";
import ArrangeItem from "@/components/ArrangeItem";
export default {
  components: {
    Pagination,
    ArrangeItem,
  },
  data() {
    return {
      reRenderTable: true,
      start: 0,
      pagination: {
        perPage: 100,
        currentPage: 1,
        total: 0,
      },
      db: {},
      listProducts: [],
      totalText: "",
      suggesstion: {
        type: [],
        name: [],
      },
      filter: {
        type: "",
        name: "",
      },
      dialogVisible: {
        arrangeItem: false,
      },
    };
  },
  async created() {
    try {
      if (this.accessories.length === 0) {
        await this.$store.dispatch("getAllAccessories");
      }
    } catch (error) {
      this.$messsageError("Lỗi khi tải danh sách phụ kiện");
    }
  },
  mounted() {
    this.db = firebase.firestore();
    this.db
      .collection(process.env.VUE_APP_SUGGESTION_LIST)
      .doc("accessories")
      .get()
      .then((doc) => {
        if (doc.exists) {
          doc.data().type.forEach((item) => {
            this.suggesstion.type.push(item);
          });
        }
      });
    let bits = localStorage.getItem("bits");
    this.db
      .collection("--stats--")
      .doc(process.env.VUE_APP_LIST_WINE + bits)
      .get()
      .then((docRef) => {
        if (docRef.exists) {
          docRef.data().listWine.forEach((item) => {
            if (!(item.productId[0] == "V" && item.productId[1] != "O")) {
              this.listProducts.push(item.productId);
              this.suggesstion.name.push(item.name);
            }
            this.totalText = "trong số " + this.listProducts.length;
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.$store.dispatch("FLAG_LOADING", false);
      });
    this.pagination.currentPage = 1;
  },
  methods: {
    goToWine() {
      this.$router.push({
        name: "Quản lý sản phẩm",
      });
    },
    addNews() {
      this.$emit("addNews");
    },
    editItem(item) {
      this.$emit("editItem", item);
    },
    async hideProduct(item) {
      try {
        let tmp = JSON.parse(JSON.stringify(item));
        tmp.data.isHide = !item.data.isHide;
        await this.$store.dispatch("updateAccessory", tmp);
      } catch (error) {
        console.log(error);
        this.$messageError("Lỗi cập nhật sản phẩm");
      }
    },
    removeItem(item) {
      Swal.fire({
        title: "Xóa mục",
        text: `Mục này sẽ bị xóa khỏi danh sách`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "OK",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.$store.dispatch("removeAccessory", item);
            this.$messageSuccess("Xóa thành công");
          } catch (error) {
            this.$messsageError("Lỗi khi xóa phụ kiện");
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters(["accessories"]),
    dataFilter() {
      var result = [];
      result = JSON.parse(JSON.stringify(this.accessories));
      if (this.filter.name !== "") {
        result = result.filter(
          (item) =>
            item.data.name
              .toLowerCase()
              .indexOf(this.filter.name.toLowerCase()) !== -1
        );
      } else if (this.filter.type !== "") {
        if (this.filter.type === "Chưa phân loại") {
          result = result.filter(
            (item) =>
              item.data.type == [] ||
              item.data.type[0] === "" ||
              item.data.type.includes("Chưa phân loại")
          );
        } else
          result = result.filter((item) =>
            item.data.type.includes(this.filter.type)
          );
      }
      return result;
    },
    queriedData() {
      let result = this.dataFilter;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.accessories.length;
    },
    nameSuggesstion() {
      return this.accessories.map((item) => item.data.name);
    },
    typeSuggesstion() {
      let set = new Set(this.accessories.map((item) => item.data.type[0]));
      set.delete("");
      set.delete(undefined);
      console.log(set);
      return Array.from(set).concat("Chưa phân loại");
    },
  },
};
</script>
<style lang="css" scoped>
.button-add {
  float: right;
}
#accessories {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
  border-radius: 10px;
}

#accessories td,
#accessories th {
  padding: 8px 10px 8px 10px;
  border: 1px solid #ddd;
  max-width: 20vh;
}

#accessories tr:nth-child(even) {
  background-color: #f2f2f2;
}

#accessories tr:hover {
  background-color: #ddd;
}

#accessories th {
  text-align: left;
  background-color: rgba(0, 165, 14, 0.356);
  color: rgb(0, 0, 0);
  font-style: normal;
  font-weight: normal;
}
.nummeric {
  text-align: right !important;
}
.pagination {
  color: rgba(0, 0, 0, 0.301);
  font-size: 13px;
}
.btnHideShow {
  border: none;
  background: rgb(122, 122, 122);
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: bold;
  color: white;
}
.btnShow {
  background: cadetblue;
}
.image-container {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 50%;
  background: white;
}
.box-image {
  width: auto;
  height: 100%;
}
</style>
